module.exports = __webpack_public_path__ + "img/model4.7c182026.png";